import axios from "axios";
import authHeader from "./AuthHeader";

const API_URL = process.env.VUE_APP_MS_MAXIMO;

class MaximoService {
  findTeamsByCustomer(customer) {
    return axios.get(`${API_URL}/secure/customer/${customer}/team`, {
      headers: authHeader(),
    });
  }

  loadLeasingAssset(customer) {
    return axios.get(`${API_URL}/secure/assets/status/customer/${customer}`, {
      headers: authHeader(),
    });
  }

  loadLeasingAsssetByAgreement(agreement, period) {
    return axios.get(
      `${API_URL}/secure/assets/agreement/${agreement}/${period}`,
      {
        headers: authHeader(),
      },
    );
  }

  //get meterdata
  getMeterdataByAsset(assetnum) {
    return axios.get(`${API_URL}/secure/meterdata/asset?asset=${assetnum}`, {
      headers: authHeader(),
    });
  }

  loadAssetsByAgreements(agreement) {
    return axios.get(`${API_URL}/secure/assets/agreements/${agreement}`, {
      headers: authHeader(),
    });
  }

  getAssetByAssetnum(assetnum) {
    return axios.get(`${API_URL}/secure/assets/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //preventive maintenance
  getAssetPMWorkorders(assetnum) {
    return axios.get(`${API_URL}/secure/workorders/pm/${assetnum}`, {
      headers: authHeader(),
    });
  }

  getLocation(location) {
    return axios.get(`${API_URL}/secure/locations/${location}`, {
      headers: authHeader(),
    });
  }

  getLastWorkorderByAssetnum(assetnum) {
    return axios.get(`${API_URL}/secure/workorders/last/${assetnum}`, {
      headers: authHeader(),
    });
  }

  loadPriority() {
    return axios.get(`${API_URL}/secure/domains/ticketpriority`, {
      headers: authHeader(),
    });
  }

  loadLocations() {
    return axios.get(`${API_URL}/secure/locations`, { headers: authHeader() });
  }

  loadServiceRequest(payload) {
    return (
      axios.post(`${API_URL}/secure/sr`, payload), { headers: authHeader() }
    );
  }

  loadServiceRequestByAsset(assetnum) {
    return axios.get(`${API_URL}/secure/sr/assets/${assetnum}`, {
      headers: authHeader(),
    });
  }

  loadWorkorders(payload) {
    return axios.post(`${API_URL}/secure/workorders`, payload, {
      headers: authHeader(),
    });
  }

  loadWoForAv(payload) {
    return axios.post(`${API_URL}/secure/workorders/srs`, payload, {
      headers: authHeader(),
    });
  }

  workordersHistory(customer) {
    return axios.get(
      `${API_URL}/secure/workorders/history?customer=${customer}`,
      { headers: authHeader() },
    );
  }

  loadWorkordersByCustomer(customer, start, end) {
    return axios.get(
      `${API_URL}/secure/cworkorders/customer?customer=${customer}&start=${start}&end=${end}`,
      { headers: authHeader() },
    );
  }

  loadSrByCustomer(customer, start, end) {
    return axios.get(
      `${API_URL}/secure/sr/customer?customer=${customer}&start=${start}&end=${end}`,
      { headers: authHeader() },
    );
  }

  loadCreatedSrByCustomer(customer, start, end) {
    return axios.get(
      `${API_URL}/secure/sr/only/customer?customer=${customer}&start=${start}&end=${end}`,
      { headers: authHeader() },
    );
  }

  loadLocoSpec(payload) {
    return axios.post(`${API_URL}/secure/sr/specs`, payload, {
      headers: authHeader(),
    });
  }

  saveSR(payload) {
    return axios.post(`${API_URL}/secure/sr`, payload, {
      headers: authHeader(),
    });
  }

  //save meterdata
  saveMeterdata(payload) {
    return axios.post(`${API_URL}/secure/meterdata`, payload, {
      headers: authHeader(),
    });
  }

  //get open Sr by asset
  getRelatedRecords(wonum) {
    return axios.get(`${API_URL}/secure/sr/workorder/${wonum}`, {
      headers: authHeader(),
    });
  }

  //get SR by asset
  getOpenSrByAsset(scope, assetnum) {
    return axios.get(`${API_URL}/secure/sr/asset/${scope}/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //get Sr description
  getSrDescription(key) {
    return axios.get(`${API_URL}/secure/longdescription/${key}`, {
      headers: authHeader(),
    });
  }

  //get Asset specification
  getAssetHomologation(assetnum) {
    return axios.get(`${API_URL}/secure/specs/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //get wheelset measurement
  getWheelsetMeasurement(params) {
    return axios.get(`${API_URL}/secure/measurements/wheelset?${params}`, {
      headers: authHeader(),
    });
  }

  //find protocol and wheel
  getProtocolAndWheel(workorderid) {
    return axios.get(`${API_URL}/secure/docLinks/${workorderid}`, {
      headers: authHeader(),
    });
  }

  getDoclinksWheelset(workorderid) {
    return axios.get(
      `${API_URL}/secure/docLinks/wheelsetmeasurements/${workorderid}`,
      {
        headers: authHeader(),
      },
    );
  }

  getDoclinksWheelsets(workorderids) {
    return axios.post(
      `${API_URL}/secure/docLinks/wheelsetmeasurements`,
      workorderids,
      {
        headers: authHeader(),
      },
    );
  }

  //find protocol
  downloadProtocol(workorderid) {
    return `${API_URL}/download/docLinks/${workorderid}`;
  }

  downloadDoc(workorderid) {
    return axios.get(`${API_URL}/secure/download/docLinks/${workorderid}`, {
      headers: authHeader(),
    });
  }

  //find whellset by asset
  getWheelsets(assetnum) {
    return axios.get(`${API_URL}/secure/wheelset/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //find whellset measure dates by asset
  getWheelsetMeasureDates(assetnum) {
    return axios.get(`${API_URL}/secure/measurements/dates/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //find whellset measure dates by asset
  getLastMeter(assetnum, metername) {
    return axios.get(
      `${API_URL}/secure/meterdata/last?asset=${assetnum}&metername=${metername}`,
      { headers: authHeader() },
    );
  }

  //find next amintenance plan
  getNextMaintenancePlan(assetnum) {
    return axios.get(`${API_URL}/secure/calcduedate/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //find next amintenance plan
  getJobPlans(customer) {
    return axios.get(`${API_URL}/secure/jobplans/${customer}`, {
      headers: authHeader(),
    });
  }

  //find next amintenance plan
  getCurrentWorkorder(assetnum) {
    return axios.get(`${API_URL}/secure/workorders/last/${assetnum}`, {
      headers: authHeader(),
    });
  }

  //find protocol
  getAttachments(sr) {
    return axios.get(`${API_URL}/secure/srattachemets/${sr}`, {
      headers: authHeader(),
    });
  }

  //find km overview
  getKmOverview(customer) {
    return axios.get(`${API_URL}/secure/meterdata/overview/${customer}`, {
      headers: authHeader(),
    });
  }

  //find km overview
  getUnleasedFleetInfo() {
    return axios.get(`${API_URL}/secure/assets/info`, {
      headers: authHeader(),
    });
  }

  //find status memo
  getStatusMemo(assetid, status) {
    return axios.get(`${API_URL}/secure/assetsthist/${assetid}/${status}`, {
      headers: authHeader(),
    });
  }

  //find workorder
  getWorkorder(wonum) {
    return axios.get(`${API_URL}/secure/workorder/${wonum}`, {
      headers: authHeader(),
    });
  }

  getQuotationDoclinks(workorderid) {
    return axios.get(`${API_URL}/secure/docLinks/quotation/${workorderid}`, {
      headers: authHeader(),
    });
  }

  loadAssetNums() {
    return axios.get(`${API_URL}/secure/assets/referential`, {
      headers: authHeader(),
    });
  }

  loadAssetByCompany(companyCode) {
    return axios.get(`${API_URL}/secure/assets/company/${companyCode}`, {
      headers: authHeader(),
    });
  }
}

export default new MaximoService();
